import { useMemo } from 'react';

import { IHeaderParams } from 'ag-grid-community';

import { AgGridKebabMenuOptions } from 'uiToolkitV1/AgGridWrapperV2/types';

import { KebabMenu } from './KebabMenu';

type Props = IHeaderParams & {
  options: AgGridKebabMenuOptions;
  kebabMenuOptionsGenerator?: (params: any) => AgGridKebabMenuOptions;
  kebabMenuIsRowSpecific?: boolean;
  getUIOptionsForLastColumn?: (params: any) => React.FC | null;
};

const KebabMenuWrapper = ({
  options = [],
  kebabMenuOptionsGenerator,
  kebabMenuIsRowSpecific = false,
  getUIOptionsForLastColumn,
  // @ts-expect-error - data is not defined in IHeaderParams
  data,
  ...rest
}: Props) => {
  const kebabMenuOptionsGeneratorExists = typeof kebabMenuOptionsGenerator === 'function' && kebabMenuIsRowSpecific;

  const generatedOptions = useMemo(() => {
    if (!kebabMenuOptionsGeneratorExists) {
      return [];
    }
    return kebabMenuOptionsGenerator(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, kebabMenuOptionsGeneratorExists]);

  const KebabMenuAlternateRenderer =
    typeof getUIOptionsForLastColumn === 'function' ? getUIOptionsForLastColumn(data) : null;
  if (KebabMenuAlternateRenderer) {
    return <KebabMenuAlternateRenderer />;
  }

  return (
    <KebabMenu
      {...rest}
      options={kebabMenuOptionsGeneratorExists ? generatedOptions : options}
      containerProps={{ justifyContent: 'flex-end' }}
    />
  );
};

export { KebabMenuWrapper };
